import {createLazyFileRoute} from '@tanstack/react-router'

import FoodGrubhubCategoryDetail from '@/views/FoodGrubhubRestaurantDetail/components/MenuItemDetail/FoodGrubhubMenuItemDetail'

export const Route = createLazyFileRoute(
  '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/',
)({
  component: FoodGrubhubCategoryDetail,
})
